import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/resource/css/reset.css';
import './assets/resource/css/common.css';
import './assets/resource/css/sub.css';
import './assets/resource/css/main.css';
import { createPinia } from 'pinia';

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(pinia);
app.mount('#app');
